import { render, staticRenderFns } from "./pd-crosssell.vue?vue&type=template&id=654799eb&"
import script from "./pd-crosssell.vue?vue&type=script&lang=js&"
export * from "./pd-crosssell.vue?vue&type=script&lang=js&"
import style0 from "./pd-crosssell.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Crosssell: require('/opt/build/repo/storefront/components/legacy/global/crosssell.vue').default})
